'use strict';

module.exports = /*@ngInject*/ function() {
	var directive = {};

	directive.restrict = 'AE';

	directive.scope = {
		onSubmit: '&'
	};

	directive.controller = 'CardFormCtrl';

	directive.controllerAs = 'cfCtrl';

	directive.templateUrl = 'trioBankCardForm/trioBankCardForm.tpl.html';

	return directive;
};
